import React from 'react';
import styled from 'styled-components';
import Hero from '../components/landing/Hero';
import Features from '../components/landing/Features';
import HowItWorks from '../components/landing/HowItWorks';
import TwoModes from '../components/landing/TwoModes';
import ComparisonTable from '../components/landing/ComparisonTable';
import FAQ from '../components/landing/FAQ';
import FinalCTA from '../components/landing/FinalCTA';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';

const PageContainer = styled.div`
  min-height: 100vh;
  background: transparent;
  color: ${({ theme }) => theme.colors.cardText};
`;

const LandingPage = ({ handleThemeChange }) => {
  return (
    <PageContainer>
      <LandingNav handleThemeChange={handleThemeChange} />
      <Hero />
      <Features />
      <HowItWorks />
      <TwoModes />
      <ComparisonTable />
      <FAQ />
      <FinalCTA />
      <LandingFooter />
    </PageContainer>
  );
};

export default LandingPage;
